import React from "react";
import { formatDate } from "../../../../../../../utils/helper";

function UsageSummaryCard({ subscription, overallUsage }) {
  const getProgressColor = (percentage) => {
    if (percentage >= 90) return "#dc3545";
    if (percentage >= 70) return "#f59e0b";
    return "#22c55e";
  };

  return (
    <div
      className="rounded-3 p-4 mb-4"
      style={{
        border: "1px solid rgba(85,91,103,.15)",
        background: "#fff",
      }}
    >
      <div className="row align-items-center">

        {/* Current Plan */}
        <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
          <div className="text-muted fs-6">Current Plan</div>

          <div className="fs-3 fw-semibold mt-1">
            {subscription?.plan?.name ?? "--"}
          </div>

          <div className="text-muted fs-6 mt-2 text-capitalize">
            {subscription?.billing_period ?? "--"} Billing
          </div>

          <div
            className="mt-3 px-3 py-1 rounded-pill d-inline-block"
            style={{
              background:
                subscription?.status === "active"
                  ? "#F0FFE6"
                  : "#FFF4E5",
              color:
                subscription?.status === "active"
                  ? "#68C230"
                  : "#E67E22",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            {subscription?.is_scheduled_for_cancellation
              ? "Scheduled for Cancellation"
              : subscription?.status}
          </div>
        </div>

        {/* Billing Cycle */}
        <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
          <div className="text-muted fs-6">
            Billing Cycle
          </div>

          <div className="fw-semibold mt-1">
            {formatDate(subscription?.current_start)}
          </div>

          <div className="text-muted fs-6">
            to
          </div>

          <div className="fw-semibold">
            {formatDate(subscription?.current_end)}
          </div>

          <div className="text-primary fs-6 mt-2 fw-semibold">
            {subscription?.days_remaining} days remaining
          </div>
        </div>

        {/* Usage Summary */}
        <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
          <div className="text-muted fs-6">
            Usage Summary
          </div>

          <div className="fs-2 fw-bold mt-1">
            {overallUsage?.totalConsumed}
          </div>

          <div className="text-muted">
            of {overallUsage?.totalAllowed} limits used
          </div>

          <div
            className="mt-2"
            style={{
              color: getProgressColor(overallUsage?.percentage),
              fontWeight: 600,
            }}
          >
            {overallUsage?.percentage}% utilized
          </div>
        </div>

        {/* Overall Usage */}
        <div className="col-lg-3 col-md-6 text-center">

          <div
            style={{
              width: 100,
              height: 100,
              margin: "0 auto",
              borderRadius: "50%",
              border: `8px solid ${getProgressColor(
                overallUsage?.percentage
              )}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
            }}
          >
            <div>
              <div className="fw-bold fs-3">
                {overallUsage?.percentage}%
              </div>

              <div
                className="text-muted"
                style={{
                  fontSize: 12,
                }}
              >
                Used
              </div>
            </div>
          </div>

          <div className="mt-3 text-muted fw-semibold">
            Overall Usage
          </div>
        </div>

      </div>

      {subscription?.is_scheduled_for_cancellation && (
        <div
          className="mt-4 rounded-3 p-3"
          style={{
            background: "#FFF8E6",
            border: "1px solid #F7D794",
          }}
        >
          <div
            className="fw-semibold"
            style={{
              color: "#B26A00",
            }}
          >
            Subscription Scheduled for Cancellation
          </div>

          <div
            className="mt-1"
            style={{
              color: "#6B7280",
            }}
          >
            {subscription.subscription_end_message}
          </div>
        </div>
      )}
    </div>
  );
}

export default UsageSummaryCard;